// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2e43990b8dbdc89ec4f1fd1ed47217b6d2998ae2.chunk.bundle.js";
};